// extracted by mini-css-extract-plugin
module.exports = {"premium-folder-icon":"_1hyvi","premiumFolderIcon":"_1hyvi"};